<p-menubar [model]="items">

  <ng-template #start>
    <div class="flex gap-3 align-items-center">
      <div class="flex align-items-center justify-content-center"><img class="mr-3" [src]="logo"
          alt="Logo" /></div>
      <!-- <div class="flex align-items-center justify-content-center logoshap"><img class="mr-3" src="assets/images/logo.svg" alt="Logo" /></div>
        <div class="">
          <div class="logo-title">Referral Portal</div>
          <div class="logo-subtitle">Employee Rewards</div>
        </div> -->
    </div>

  </ng-template>

  <ng-template #item let-item let-root="root">
    <a pRipple class="flex align-items-center p-menubar-item-link" [routerLink]="item.routerLink"
      [queryParams]="item.queryParams"
      [class.active]="isNavItemActive(item)">
      <span>{{ item.label }}</span>
    </a>
  </ng-template>

  <ng-template #end>
    <div class="flex align-items-center gap-2">
      <!-- Avatar button -->
      <p-button (click)="menu.toggle($event)" styleClass="p-button-text">
        <ng-template pTemplate="content">
          <p-avatar class="pi pi-user"
            shape="circle" ></p-avatar>
        </ng-template>
      </p-button>

      <!-- Tiered menu -->
      <p-tieredMenu #menu [model]="itemsHp" [popup]="true">
        <ng-template pTemplate="item" let-item>

          <ng-container *ngIf="item.label === '__profile__'">
            <div class="flex align-items-center gap-2 p-2">
              <p-avatar class="pi pi-user" shape="circle"
                size="normal"></p-avatar>
              <div>
                <div class="font-semibold text-base">{{ fullName }}</div>
                <!-- <div class="text-sm text-gray-500">Java Developer</div> -->
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="item.label !== '__profile__' && item.label !== 'Logout' && item.label !== 'Company'">
            <div class="flex items-center gap-2 px-3 py-2 cursor-pointer" (click)="onMenuItemClick(item)"
              role="menuitem">

              <svg *ngIf="item.svgIcon" width="18" height="18" class="flex-shrink-0">
                <use [attr.href]="'assets/images/icon-library.svg#' + item.svgIcon"></use>
              </svg>

              <span>{{ item.label }}</span>
            </div>
          </ng-container>

          <ng-container *ngIf="item.label === 'Logout'">
            <div class="flex align-items-center gap-2 py-2 px-3 cursor-pointer" (click)="onLogout()" role="menuitem">
              <svg width="18" height="18" class="flex-shrink-0">
                <use [attr.href]="'assets/images/icon-library.svg#' + item.svgIcon"></use>
              </svg>
              <span>{{ item.label }}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="item.label === 'Company'">
            <div class="flex align-items-center gap-2 py-2 px-3"  role="menuitem">
              <i class="pi pi-building"></i>
              <span>{{ companyName }}</span>
            </div>
          </ng-container>

        </ng-template>
      </p-tieredMenu>
    </div>
  </ng-template>
</p-menubar>

<!-- Change Password Start-->
<!-- <p-dialog [(visible)]="showChangePasswordDialog " [modal]="true" [style]="{ width: '30rem' }">
  <ng-template #header>
    <div class="inline-flex items-center justify-center gap-2">
      <span class="popup-title">Change Password</span>
    </div>
  </ng-template>
  <div class="formgrid grid formRow">
    <form [formGroup]="changePasswordForm" class="w-full">
      <div class="forgotPassword">

        <div class="formBlock">
          <div class="field formRow mb-4">
            <label class="formL-1">Current Password <span class="mandatory">*</span></label>
            <div class="formL-2">
              <input pInputText type="text" id="currentPassword" placeholder="" formControlName="currentPassword" />
            </div>
          </div>

          <div class="field formRow mb-4">
            <label class="formL-1">New Password <span class="mandatory">*</span></label>
            <div class="formL-2">
              <input pInputText type="text" id="newPassword" placeholder="" formControlName="newPassword" />
            </div>
          </div>


          <div class="field formRow mb-4">
            <label class="formL-1">Confirm Password <span class="mandatory">*</span></label>
            <div class="formL-2">
              <input pInputText type="text" id="confirmPassword" placeholder="" formControlName="confirmPassword" />
            </div>
          </div>

          <div class="field formRow mb-2">
            <p-button label="Save" class="pActBtn mr-2"></p-button>
            <p-button label="Cancel" class="pActBtn" severity="secondary" variant="outlined"></p-button>
          </div>

        </div>
      </div>
    </form>


  </div>
</p-dialog> -->
<!--End Change Password -->

<p-dialog
  header="Guidelines"
  [closable]="showCloseButton"
  [(visible)]="visible"
  [style]="{ width: '80rem' }"
  [appendTo]="'body'"
   modal="true"
 
>
  <div class="guidelines-content">
    <div [innerHTML]="guidelines"></div>
    <!-- <p>
      “Referral Porter” is not a formally recognized or standardized professional title in the traditional sense.
      Instead, it is a contextual or informal term used to describe an individual who participates in referring
      customers, partners, or service providers to a company like Porter. Porter is an on-demand logistics and
      transportation platform in India that connects users with delivery vehicles and services for moving goods
      efficiently across cities.
    </p>
    <p>
      n this context, a “Referral Porter” typically acts as a promoter or advocate for the platform, helping to expand
      its user base through word-of-mouth, referral programs, or affiliate incentives. These individuals may share
      referral codes, invite new users to sign up, or recommend Porter’s services to businesses and individuals who
      require logistics support. Their role is not official employment but rather participation in a growth or marketing
      initiative driven by user engagement.
    </p>
    <p>
      Such referral roles are common in modern digital platforms, especially in gig economy and app-based services,
      where companies leverage existing users to drive organic growth. Referral participants may receive benefits such
      as discounts, credits, or monetary rewards when their referrals successfully complete transactions. This system
      not only helps companies like Porter scale quickly but also creates a mutually beneficial ecosystem where users
      are incentivized to promote services they find useful.
    </p>
    <p>
      Overall, the term “Referral Porter” should be understood as a functional description rather than a job
      title—representing a user or individual contributing to the platform’s expansion through referrals rather than
      holding a defined organizational role.
    </p> -->
  </div>
  @if(!showCloseButton) {
  <ng-template #footer>
    <p-button label="Accept" (click)="acceptGuidelines()" />
  </ng-template>
}
</p-dialog>
